import { BaseRestRepository } from './baseRestRepository';

const ONBOARDING_URL = `/api/companies/onboarding`;
const NOTIFICATIONS_URL = `/api/notifications`;
const DEBUG_URL = `/api/debug`;
const PAYMENTS_URL = `/api/companies/payments`;

const DEBUG_HEADERS = {
  'X-Client-Id': 'dev',
  'X-Client-Secret': '0193af6e-c8c4-729c-8745-84f9f030c400',
};

export class OnboardingRepository extends BaseRestRepository {
  public async updateOnboardingStep(status: string) {
    const response = await this.fetchWithAuth(`${ONBOARDING_URL}/status`, {
      method: 'PUT',
      body: JSON.stringify({ status }),
    });
    return this.getJsonResponse(response);
  }

  public async completeOnboarding(): Promise<MagicDoor.Api.CompanyDto> {
    const response = await this.fetchWithAuth(ONBOARDING_URL, {
      method: 'PATCH',
    });
    return this.getJsonResponse(response);
  }

  public async getIsCompanyPaid(): Promise<MagicDoor.Api.CompanyPaymentsDto> {
    const response = await this.fetchWithAuth(`${PAYMENTS_URL}/check`);
    return this.getJsonResponse(response);
  }

  public async getPlannedNotifications(): Promise<MagicDoor.Api.NotificationScheduleDtoPaginationDto> {
    const response = await this.fetchWithAuth(`${NOTIFICATIONS_URL}/schedules`);
    return this.getJsonResponse(response);
  }

  public async debugSendNotification(scheduleId: string): Promise<void> {
    await this.fetchWithAuth(`${DEBUG_URL}/notifications/schedules/${scheduleId}/send`, {
      method: 'POST',
      headers: DEBUG_HEADERS,
    });
  }

  public async getNotificationSchedule(scheduleId: string): Promise<MagicDoor.Api.NotificationScheduleDto> {
    const response = await this.fetchWithAuth(`${NOTIFICATIONS_URL}/schedules/${scheduleId}`);
    return this.getJsonResponse(response);
  }

  public async createNotificationSchedule(
    schedule: MagicDoor.Api.CreateNotificationScheduleDto
  ): Promise<MagicDoor.Api.NotificationScheduleDto> {
    const response = await this.fetchWithAuth(`${NOTIFICATIONS_URL}/schedules`, {
      method: 'POST',
      body: JSON.stringify(schedule),
    });
    return this.getJsonResponse(response);
  }

  public async updateNotificationSchedule(
    notificationScheduleId: string,
    schedule: MagicDoor.Api.UpdateNotificationScheduleDto
  ): Promise<MagicDoor.Api.NotificationScheduleDto> {
    const response = await this.fetchWithAuth(`${NOTIFICATIONS_URL}/schedules/${notificationScheduleId}`, {
      method: 'PUT',
      body: JSON.stringify(schedule),
    });
    return this.getJsonResponse(response);
  }

  public async deleteNotificationSchedule(scheduleId: string): Promise<void> {
    await this.fetchWithAuth(`${NOTIFICATIONS_URL}/schedules/${scheduleId}`, {
      method: 'DELETE',
    });
  }
}

export const onboardingRepository = new OnboardingRepository();
